<template>
  <div class="keypal-card-instructions">
    <Header isKeyPal />
    <main>
      <div class="main-header">
        <!-- <p>
          KeyPal Card <span>{{ $t('keypalTutorial.text_1_1') }}</span>
        </p> -->
        <div class="pc-img">
          <img class="pc" :src="mainHeaderImg" alt="" />
        </div>
        <img class="mobile" :src="mainHeaderImgMobile" alt="" />
      </div>
      <div class="main-container">
        <div class="tab-list">
          <div
            class="tab-item"
            :class="{ active: tutorialTab === item.tab }"
            v-for="(item, index) in tutorialTabList"
            :key="index"
            @click="onTab(item.tab)"
          >
            <div class="tab-wrap">
              <div class="title">{{ item.title }}</div>
              <div v-if="item.desc" class="desc">{{ item.desc }}</div>
            </div>
          </div>
        </div>
        <!-- <div class="process-list" v-if="processList.length">
          <div
            class="process-item"
            :class="{ active: curProcess === item.process }"
            v-for="(item, index) in processList"
            :key="index"
            @click="onProcess(item)"
          >
            <div class="process-wrap">
              <img :src="item.icon" alt="" />
              <div class="title">{{ item.title }}</div>
            </div>
          </div>
        </div> -->
        <div class="step-container">
          <!-- <div class="step-triangle">
            <div
              class="step-triangle-item"
              v-for="(item, index) in processList"
              :key="index"
            >
              <svg
                v-if="curProcess === item.process"
                width="50"
                height="30"
                viewBox="-50 -50 300 300"
              >
                <polygon
                  class="triangle radius"
                  stroke-linejoin="round"
                  points="100,0 -80,200 280,200"
                />
              </svg>
            </div>
          </div> -->
          <!-- <div class="step-header" v-if="tutorialTab === 'backup'"></div> -->
          <div
            class="step-content"
            :class="{ isBackup: tutorialTab === 'backup' }"
          >
            <div
              class="header-list"
              :class="{ isBackup: tutorialTab === 'backup' }"
            >
              <template v-if="tutorialTab === 'backup'">
                <div
                  class="item"
                  :class="{ active: curProcess === item.process }"
                  v-for="(item, index) in processList"
                  :key="index"
                  @click="onProcess(item)"
                >
                  {{ item.title }}
                </div>
              </template>
              <div v-else class="title">{{ stepData.title }}</div>
              <div
                class="video-item"
                :class="{ isBackup: tutorialTab === 'backup' }"
                @click="playTutorialVideo"
              >
                <img
                  src="../assets/images/keypal-card-instructions/play.png"
                  alt=""
                />
                <span>{{ $t('keypalTutorial.tutorialVideo') }}</span>
              </div>
            </div>
            <!-- <div class="title">{{ stepData.title }}</div> -->
            <div class="desc" v-if="stepData.desc">
              {{ stepData.desc }}
            </div>
            <div class="step-box" v-if="stepData.list">
              <div class="box-left">
                <div class="step-list">
                  <div
                    class="step-item"
                    v-for="(item, index) in stepData.list"
                    :key="index"
                    @mouseenter="onMouseEnter(item, index)"
                    @mouseleave="onMouseLeave"
                  >
                    <div
                      class="step-wrap"
                      ref="step-wrap"
                      :class="{ active: stepDataListRightIndex >= index }"
                    >
                      <div class="sort">
                        <span>{{ index + 1 }}</span>
                        <div
                          class="step-line"
                          :style="{ height: item.lineHeight + 'px' }"
                        ></div>
                      </div>
                      <p>
                        {{ item.text }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="box-right">
                <img
                  v-if="stepDataListRight"
                  :src="stepDataListRight.img"
                  alt=""
                />
              </div>
            </div>
            <div v-else class="step-box-2">
              <img :src="createWalletPcImg" alt="" />
            </div>
            <div class="step-box-mobile">
              <SwiperView
                v-if="stepData && stepData.list"
                :swiperData="stepData.list[this.swiperIndex]"
                @onSwitch="onSwitch"
              />
              <!-- createWalletList -->
              <SwiperView
                v-else
                :swiperData="createWalletList[this.swiperIndex]"
                @onSwitch="onSwitch"
              />
            </div>
          </div>
        </div>
        <div class="precautions">
          <p class="title">{{ precautionsMap.title }}</p>
          <p v-for="(item, index) in precautionsMap.list" :key="index">
            {{ item.text }}
          </p>
        </div>
      </div>
    </main>
    <Footer />
    <div class="video-play-container" v-show="isVideo">
      <div class="video-play-content">
        <video
          id="tutorial-video"
          :src="tutorialVideo"
          controls
          x5-video-player-fullscreen="true"
          x5-video-player-type="h5"
          playsinline="true"
          webkit-playsinline="true"
        ></video>
      </div>
    </div>
  </div>
</template>

<script>
import Footer from '../components/common/Footer.vue';
import Header from '../components/common/Header.vue';
import SwiperView from '../components/common/SwiperView.vue';
export default {
  components: { Header, Footer, SwiperView },
  data() {
    return {
      tutorialTab: 'backup',
      processIndex: 0,
      stepDataListRight: {},
      stepDataListRightIndex: 0,
      curProcess: 'Create Wallet',
      stepLineList: [],
      swiperIndex: 0,
      isVideo: false,
    };
  },
  mounted() {
    // 默认选中第一个
    this.stepDataListRight = this.stepData.list && this.stepData.list[0];
    document.addEventListener('click', this.onOutside);
  },
  computed: {
    langImg() {
      if (this.$i18n.locale === 'zh') {
        return '';
      } else {
        return '-en';
      }
    },
    videoLang() {
      let lang = '-en';
      if (this.$i18n.locale === 'zh') {
        lang = '-zh';
      } else if (this.$i18n.locale === 'zh-tw') {
        lang = '-zh-tw';
      }
      return lang;
    },
    tutorialVideo() {
      return `https://hkg.bcebos.com/tp-statics-hk/keypal-card/${this.tutorialTab}${this.videoLang}.mp4`;
    },
    createWalletPcImg() {
      return require(`../assets/images/keypal-card-instructions/create-wallet${this.langImg}.png`);
    },
    createWalletList() {
      return [
        {
          index: 1,
          img: require(`../assets/images/keypal-card-instructions/create-wallet-m-1${this.langImg}.png`),
        },
        {
          index: 2,
          img: require(`../assets/images/keypal-card-instructions/create-wallet-m-2${this.langImg}.png`),
        },
        {
          index: 3,
          img: require(`../assets/images/keypal-card-instructions/create-wallet-m-3${this.langImg}.png`),
        },
        {
          index: 4,
          img: require(`../assets/images/keypal-card-instructions/create-wallet-m-4${this.langImg}.png`),
        },
      ];
    },
    mainHeaderImg() {
      let str = 'zh';
      if (this.$i18n.locale === 'en') {
        str = 'en';
      }
      return require(`../assets/images/keypal-card-instructions/header-bg-${str}.png`);
    },
    mainHeaderImgMobile() {
      let str = 'zh';
      if (this.$i18n.locale === 'en') {
        str = 'en';
      }
      return require(`../assets/images/keypal-card-instructions/header-bg-m-${str}.png`);
    },
    tutorialTabList() {
      return [
        {
          title: this.$t('keypalTutorial.text_2_1'),
          tab: 'backup',
        },
        {
          title: this.$t('keypalTutorial.text_2_2'),
          tab: 'import',
        },
        {
          title: this.$t('keypalTutorial.text_2_3'),
          desc: this.$t('keypalTutorial.text_2_4'),
          tab: 'advanced',
        },
      ];
    },
    backUpList() {
      return [
        {
          icon: require('../assets/images/keypal-card-instructions/process-1.png'),
          title: this.$t('keypalTutorial.text_3_1'),
          process: 'Create Wallet',
        },
        {
          icon: require('../assets/images/keypal-card-instructions/process-2.png'),
          title: this.$t('keypalTutorial.text_3_2'),
          process: 'Backup Process',
        },
        {
          icon: require('../assets/images/keypal-card-instructions/process-3.png'),
          title: this.$t('keypalTutorial.text_3_3'),
          process: 'Verification Process',
        },
      ];
    },
    backUpMap() {
      return {
        'Create Wallet': {
          title: this.$t('keypalTutorial.text_3_1'),
          desc: this.$t('keypalTutorial.text_3_1_1'),
        },
        'Backup Process': {
          title: this.$t('keypalTutorial.text_3_2'),
          desc: this.$t('keypalTutorial.text_3_2_1'),
          list: [
            {
              index: 1,
              text: this.$t('keypalTutorial.text_3_2_2'),
              img: require(`../assets/images/keypal-card-instructions/backup-1${this.langImg}.png`),
            },
            {
              index: 2,
              text: this.$t('keypalTutorial.text_3_2_3'),
              img: require(`../assets/images/keypal-card-instructions/backup-2${this.langImg}.png`),
              lineHeight: this.stepLineList[0],
            },
            {
              index: 3,
              text: this.$t('keypalTutorial.text_3_2_4'),
              img: require(`../assets/images/keypal-card-instructions/backup-3${this.langImg}.png`),
              lineHeight: this.stepLineList[1],
            },
            {
              index: 4,
              text: this.$t('keypalTutorial.text_3_2_5'),
              lineHeight: this.stepLineList[2],
            },
          ],
        },
        'Verification Process': {
          title: this.$t('keypalTutorial.text_3_3'),
          list: [
            {
              index: 1,
              text: this.$t('keypalTutorial.text_3_3_1'),
              img: require(`../assets/images/keypal-card-instructions/verification-process-1${this.langImg}.png`),
            },
            {
              index: 2,
              text: this.$t('keypalTutorial.text_3_3_2'),
              img: require(`../assets/images/keypal-card-instructions/verification-process-2${this.langImg}.png`),
              lineHeight: this.stepLineList[0],
            },
            {
              index: 3,
              text: this.$t('keypalTutorial.text_3_3_3'),
              lineHeight: this.stepLineList[1],
            },
          ],
        },
      };
    },
    importMap() {
      return {
        title: this.$t('keypalTutorial.text_4_1'),
        desc: this.$t('keypalTutorial.text_4_2_1'),
        list: [
          {
            index: 1,
            text: this.$t('keypalTutorial.text_4_3_1'),
            img: require(`../assets/images/keypal-card-instructions/import-1${this.langImg}.png`),
          },
          {
            index: 2,
            text: this.$t('keypalTutorial.text_4_3_2'),
            img: require(`../assets/images/keypal-card-instructions/import-2${this.langImg}.png`),
            lineHeight: this.stepLineList[0],
          },
          {
            index: 3,
            text: this.$t('keypalTutorial.text_4_3_3'),
            img: require(`../assets/images/keypal-card-instructions/import-3${this.langImg}.png`),
            lineHeight: this.stepLineList[1],
          },
          {
            index: 4,
            text: this.$t('keypalTutorial.text_4_3_4'),
            img: require(`../assets/images/keypal-card-instructions/import-4${this.langImg}.png`),
            lineHeight: this.stepLineList[2],
          },
        ],
      };
    },
    advancedMap() {
      return {
        title: this.$t('keypalTutorial.text_5_1'),
        desc: this.$t('keypalTutorial.text_5_2_1'),
        list: [
          {
            index: 1,
            text: this.$t('keypalTutorial.text_5_3_1'),
            img: require(`../assets/images/keypal-card-instructions/advance-1${this.langImg}.png`),
          },
          {
            index: 2,
            text: this.$t('keypalTutorial.text_5_3_2'),
            img: require(`../assets/images/keypal-card-instructions/advance-2${this.langImg}.png`),
            lineHeight: this.stepLineList[0],
          },
          {
            index: 3,
            text: this.$t('keypalTutorial.text_5_3_3'),
            img: require(`../assets/images/keypal-card-instructions/advance-3${this.langImg}.png`),
            lineHeight: this.stepLineList[1],
          },
          {
            index: 4,
            text: this.$t('keypalTutorial.text_5_3_4'),
            img: require(`../assets/images/keypal-card-instructions/advance-4${this.langImg}.png`),
            lineHeight: this.stepLineList[2],
          },
        ],
      };
    },
    stepData() {
      if (this.tutorialTab === 'backup') {
        return this.backUpMap[this.curProcess];
      } else if (this.tutorialTab === 'import') {
        return this.importMap;
      } else if (this.tutorialTab === 'advanced') {
        return this.advancedMap;
      } else {
        return this.backUpMap['Create Wallet'];
      }
    },
    processList() {
      if (this.tutorialTab === 'backup') {
        return this.backUpList;
      } else if (this.tutorialTab === 'import') {
        return [];
      } else if (this.tutorialTab === 'advanced') {
        return [];
      } else {
        return [];
      }
    },
    precautionsMap() {
      if (this.tutorialTab === 'backup') {
        return {
          title: this.$t('keypalTutorial.text_3_4'),
          list: [
            { text: this.$t('keypalTutorial.text_3_4_1') },
            { text: this.$t('keypalTutorial.text_3_4_2') },
            { text: this.$t('keypalTutorial.text_3_4_3') },
            { text: this.$t('keypalTutorial.text_3_4_4') },
            { text: this.$t('keypalTutorial.text_3_4_5') },
          ],
        };
      } else if (this.tutorialTab === 'import') {
        return {
          title: this.$t('keypalTutorial.text_4_4'),
          list: [
            { text: this.$t('keypalTutorial.text_4_4_1') },
            { text: this.$t('keypalTutorial.text_4_4_2') },
            { text: this.$t('keypalTutorial.text_4_4_3') },
          ],
        };
      } else {
        return {
          title: this.$t('keypalTutorial.text_5_4'),
          list: [
            { text: this.$t('keypalTutorial.text_5_4_1') },
            { text: this.$t('keypalTutorial.text_5_4_2') },
          ],
        };
      }
    },
  },
  watch: {
    '$i18n.locale'() {
      this.computedStepLineHeight();
      this.stepDataListRight =
        this.stepData.list && this.stepData.list[this.stepDataListRightIndex];
    },
  },
  methods: {
    onOutside(e) {
      const video = document.querySelector('#tutorial-video');
      const videoItem = document.querySelector('.video-item');
      if (
        videoItem &&
        video &&
        !video.contains(e.target) &&
        !videoItem.contains(e.target)
      ) {
        this.isVideo = false;
        video.pause();
      }
    },
    playTutorialVideo() {
      const video = document.querySelector('#tutorial-video');
      // console.log('video', video);
      if (video) {
        this.isVideo = true;
        video.play();
      }
    },
    onSwitch(index) {
      console.log('index', index);
      if (this.curProcess === 'Create Wallet') {
        if (this.createWalletList[index - 1]) {
          this.swiperIndex = index - 1;
        }
      } else {
        if (this.stepData.list[index - 1]) {
          this.swiperIndex = index - 1;
        }
      }
    },
    /** 计算步骤下虚线的高度 */
    computedStepLineHeight() {
      this.$nextTick(() => {
        // console.log('ref', this.$refs);
        const refList = this.$refs && this.$refs['step-wrap'];
        // console.log('refList', refList);
        let arr = [];
        if (refList && Array.isArray(refList)) {
          for (let index = 0; index < refList.length; index++) {
            if (index >= 1) {
              let height =
                refList[index].clientHeight - refList[index - 1].clientHeight;
              // console.log('height', height);
              height =
                (refList[index].clientHeight - 24) / 2 +
                (refList[index - 1].clientHeight - 24) / 2;
              arr.push(height + 30);
            }
          }
        }
        // console.log('arr', arr);
        this.stepLineList = arr;
      });
    },
    onTab(tab) {
      this.swiperIndex = 0;
      this.tutorialTab = tab;
      this.stepDataListRight = this.stepData.list && this.stepData.list[0];
      this.computedStepLineHeight();
    },
    onMouseEnter(data, index) {
      this.stepDataListRight = data;
      this.stepDataListRightIndex = index;
    },
    onMouseLeave() {
      // this.stepDataListRightIndex = 0;
    },
    onProcess(data) {
      this.swiperIndex = 0;
      this.curProcess = data.process;
      this.stepDataListRight = this.stepData.list && this.stepData.list[0];
      this.computedStepLineHeight();
    },
  },
};
</script>

<style lang="scss" scoped>
.keypal-card-instructions {
  main {
    background: #f7f8fa;
    .main-header {
      background: #fff;
      .pc-img {
        display: block;
        max-width: 14.4rem;
        margin: 0 auto;
        .pc {
          width: 100%;
          height: auto;
        }
      }
      .mobile {
        display: none;
      }
    }
    .main-container {
      max-width: 12rem;
      margin: 0.32rem auto 0;
      padding-bottom: 0.64rem;
      .tab-list {
        width: fit-content;
        margin: 0 auto;
        background: #fff;
        border-radius: 0.08rem;
        display: flex;
        padding: 0.06rem 0.08rem;
        box-shadow: 0 0.03rem 0.16rem 0 rgba(111, 119, 126, 0.1);
        .tab-item {
          padding: 0.07rem 0.46rem;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          &.active {
            background: #2980fe;
            border-radius: 0.11rem;
            box-shadow: 0px 0.04rem 0.01rem 0px rgba(94, 136, 174, 0.04),
              0px 0.04rem 0.09rem 0px rgba(69, 116, 170, 0.12);
            .tab-wrap {
              .title {
                color: #fff;
              }
              .desc {
                color: #fff;
              }
            }
          }
          .tab-wrap {
            .title {
              font-size: 0.16rem;
              font-family: PingFang SC, PingFang SC-600;
              font-weight: 600;
              color: #3a3b3d;
            }
            .desc {
              font-size: 12px;
              font-family: PingFang SC, PingFang SC-500;
              font-weight: 500;
              text-align: center;
              color: #c0c3c6;
            }
          }
        }
      }
      .process-list {
        margin-top: 0.48rem;
        display: flex;
        justify-content: space-between;
        .process-item {
          width: 30%;
          background: #ffffff;
          border: 0.02rem solid #fff;
          border-radius: 24px;
          padding: 0.24rem 0;
          cursor: pointer;
          box-sizing: content-box;
          &.active {
            position: relative;
            background: #ebf4ff;
            border: 0.02rem solid #2980fe;
            .process-wrap {
              .title {
                color: #3a3b3d;
              }
            }
          }
          .process-wrap {
            display: flex;
            flex-direction: column;
            align-items: center;
            img {
              width: 0.59rem;
              height: 0.59rem;
            }
            .title {
              margin-top: 0.12rem;
              font-size: 0.2rem;
              font-family: 'SemiBold';
              color: #3a3b3d;
            }
          }
        }
      }
      .step-container {
        margin-top: 0.32rem;
        .step-triangle {
          display: flex;
          justify-content: space-between;
          .step-triangle-item {
            position: relative;
            width: 30%;
            height: 0.2rem;
            svg {
              position: absolute;
              left: 50%;
              transform: translateX(-50%);
            }
            .triangle {
              fill: #fff;
              stroke: #fff;
              stroke-width: 5;
            }
            // 可以通过 stroke-width 控制圆角大小
            .radius {
              stroke-width: 100;
            }
          }
        }
        .step-header {
          position: relative;
          border-radius: 0.24rem 0.24rem 0 0;
          height: 0.54rem;
          background: #2980fe;
        }
        .step-content {
          max-width: 12rem;
          background: #ffffff;
          border-radius: 0.24rem;
          box-shadow: 0 0.03rem 0.16rem 0 rgba(111, 119, 126, 0.1);
          padding: 0.4rem 0.45rem;
          .header-list {
            display: flex;
            align-items: center;
            // &.isBackup {
            //   align-items: baseline;
            // }
            .item {
              font-size: 0.18rem;
              font-weight: 500;
              color: #3a3b3d;
              cursor: pointer;
              &.active {
                font-size: 0.24rem;
                font-weight: 600;
                color: #2980fe;
              }
              &:nth-child(n + 2) {
                margin-left: 0.32rem;
              }
            }
            .video-item {
              margin-left: 0.32rem;
              display: flex;
              align-items: center;
              padding: 0.04rem 0.08rem;
              background: #ebf4ff;
              border-radius: 0.32rem;
              cursor: pointer;
              img {
                width: 0.24rem;
                height: 0.24rem;
              }
              span {
                margin-left: 0.04rem;
                font-size: 0.14rem;
                font-weight: 600;
                color: #2980fe;
              }
            }
          }
          .title {
            font-size: 0.24rem;
            font-family: MiSans, MiSans-600;
            font-weight: 600;
            color: #3a3b3d;
          }
          .desc {
            margin-top: 0.23rem;
            font-size: 0.12rem;
            font-family: MiSans, MiSans-400;
            color: #9ea0a5;
          }
          .step-box {
            margin-top: 0.5rem;
            display: flex;
            .box-left {
              width: 4rem;
              margin-right: 0.5rem;
              .step-list {
                .step-item {
                  &:not(:last-child) {
                    padding-bottom: 0.4rem;
                  }
                  .step-wrap {
                    display: flex;
                    align-items: center;
                    cursor: pointer;
                    &.active {
                      .sort {
                        border: 0.02rem solid #2980fe;
                        span {
                          color: #2980fe;
                        }
                        .step-line {
                          border-left: 0.02rem dotted #2980fe;
                        }
                      }
                      p {
                        color: #2980fe;
                      }
                    }
                    .sort {
                      position: relative;
                      width: 0.24rem;
                      height: 0.24rem;
                      border: 0.02rem solid #3a3b3d;
                      border-radius: 50%;
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      span {
                        font-size: 0.14rem;
                        color: #3a3b3d;
                      }
                      .step-line {
                        position: absolute;
                        left: 50%;
                        transform: translateX(-50%);
                        border-left: 0.02rem dotted #000;
                        bottom: 0.27rem;
                      }
                    }
                    p {
                      flex: 1;
                      margin-left: 0.16rem;
                      font-size: 0.12rem;
                      font-weight: 500;
                      color: #3a3b3d;
                    }
                  }
                }
              }
            }
            .box-right {
              flex: 1;
              display: flex;
              align-items: center;
              justify-content: center;
              height: 3.8rem;
              img {
                width: auto;
                height: 100%;
              }
            }
          }
          .step-box-2 {
            margin: 0.32rem 0 0 0.6rem;
            img {
              width: 9.93rem;
              height: 4.9rem;
            }
          }
          .step-box-mobile {
            display: none;
          }
        }
      }
      .precautions {
        margin-top: 0.24rem;
        padding: 0.16rem 0.24rem;
        background: #ffecec;
        border-radius: 0.24rem;
        p {
          font-size: 0.12rem;
          font-weight: 500;
          color: #f56459;
          line-height: 0.17rem;
        }
        .title {
          font-size: 0.16rem;
          margin-bottom: 0.08rem;
          line-height: normal;
        }
      }
    }
  }
  .video-play-container {
    position: fixed;
    width: 100vw;
    height: 100vh;
    top: 0;
    background: rgba(0, 0, 0, 0.72);
    .video-play-content {
      max-width: 8.5rem;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      #tutorial-video {
        width: 100%;
        border-radius: 0.32rem;
      }
    }
  }
}
@media screen and (max-width: 767px) {
  .keypal-card-instructions {
    main {
      .main-header {
        .pc-img {
          display: none;
        }
        .mobile {
          display: block;
          width: 100%;
          height: auto;
        }
      }
      .main-container {
        padding: 0 0.32rem 1.44rem;
        .tab-list {
          width: 100%;
          justify-content: space-between;
          border-radius: 0.24rem;
          padding: 0.08rem;
          .tab-item {
            flex: 1;
            // padding: 0.2rem 0.3rem;
            padding: 0.2rem 0;
            &.active {
              border-radius: 0.2rem;
            }
            .tab-wrap {
              display: flex;
              flex-direction: column;
              align-items: center;
              .title {
                font-size: 0.24rem;
              }
            }
          }
        }
        .process-list {
          .process-item {
            border-radius: 0.24rem;
            &.active {
              background: #ebf4ff;
              .process-wrap {
                .title {
                  color: #3a3b3d;
                }
              }
            }
          }
        }
        .step-container {
          .step-content {
            width: 100%;
            .header-list {
              flex-wrap: wrap;
              .item {
                font-size: 0.28rem;
                &.active {
                  font-size: 0.36rem;
                }
                &:nth-child(n + 2) {
                  margin-left: 0.4rem;
                }
              }
              .video-item {
                padding: 0.12rem 0.2rem;
                margin-left: 0.32rem;
                &.isBackup {
                  margin-left: 0;
                  margin-top: 0.32rem;
                }
                img {
                  width: 0.32rem;
                  height: 0.32rem;
                }
                span {
                  font-size: 0.24rem;
                }
              }
            }
            .title {
              font-size: 0.36rem;
            }
            .desc {
              font-size: 0.24rem;
            }
            .step-box {
              display: none;
            }
            .step-box-2 {
              display: none;
            }
            .step-box-mobile {
              display: block;
            }
          }
        }
        .precautions {
          margin-top: 0.48rem;
          p {
            font-size: 0.24rem;
            line-height: 0.32rem;
          }
          .title {
            font-size: 0.26rem;
          }
        }
      }
    }
    .video-play-container {
      .video-play-content {
        max-width: none;
        width: 90%;
      }
    }
  }
}
</style>
